import { render, staticRenderFns } from "./FrequencySettingsEdit.vue?vue&type=template&id=e917617e&scoped=true"
import script from "./FrequencySettingsEdit.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e917617e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e917617e')) {
      api.createRecord('e917617e', component.options)
    } else {
      api.reload('e917617e', component.options)
    }
    module.hot.accept("./FrequencySettingsEdit.vue?vue&type=template&id=e917617e&scoped=true", function () {
      api.rerender('e917617e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencySettingsEdit.vue"
export default component.exports